const legalAgeSettings = [
  'ADDITION_LEGAL_AGE_ALCOHOL',
  'ADDITION_LEGAL_AGE_TABACCO'
];

const init = (store, settings) => {
  const legalAge = [];

  (settings ?? [])?.forEach((settingItem) => {
    if (legalAgeSettings.includes(settingItem.key)) {
      legalAge.push(settingItem);
    }

    if ('ADDITION_ALCOHOL_LIMIT_PER_DAY' === settingItem.key) {
      store.dispatch('setLimitAlcoholPerDay', parseInt(settingItem.value));
    }

    if ('ADDITION_LOGOUT_ON_CHIT_PRINT' === settingItem.key) {
      store.dispatch('setLogoutOnChitPrint', parseInt(settingItem.value));
    }
  })

  store.dispatch('setLegalAge', legalAge);
}

export {
  init,
}
